/**
 * @file
 * Site-search toggle functionality.
 */

(($, { behaviors }) => {
  /**
   * Toggles the aria-expanded attribute on the given element.
   *
   * @param {jQuery} $element
   *   The element that is currently being toggled.
   */
  function toggleAriaExpanded($element) {
    if ($element.attr("aria-expanded") === "true") {
      $element.attr("aria-expanded", "false");
    } else {
      $element.attr("aria-expanded", "true");
    }
  }

  /**
   * Toggle site-search.
   *
   * @param {jQuery} $searchToggle
   *   A search-toggle DOM element.
   */
  function toggleSiteSearch($searchToggle) {
    const $siteSearch = $(".js-site-search");
    const $siteSearchInput = $siteSearch.find("input[role='search']");

    $searchToggle.toggleClass("is-active");

    $siteSearch.slideToggle("fast", () => {
      if ($searchToggle.attr("aria-expanded", "true")) {
        $siteSearchInput.focus();
      }
    });

    toggleAriaExpanded($searchToggle);
  }

  /**
   * Attaches behaviors for site-search toggling.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches site-search toggle functionality.
   */
  behaviors.siteSearchToggle = {
    attach() {
      once("search-toggle-pressed", ".js-search-toggle").forEach((element) => {
        element.addEventListener(
          "click",
          _.debounce(() => {
            toggleSiteSearch($(element));
          }, 150)
        );
      });
    }
  };
})(jQuery, Drupal);
